var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2408_5137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36C8.082 36 0 27.918 0 18C0 8.082 8.082 0 18 0C27.918 0 36 8.082 36 18C36 27.918 27.918 36 18 36ZM18 3.6C10.062 3.6 3.6 10.062 3.6 18C3.6 25.938 10.062 32.4 18 32.4C25.938 32.4 32.4 25.938 32.4 18C32.4 10.062 25.938 3.6 18 3.6ZM19.8 27H18C17.01 27 16.2 26.19 16.2 25.2V19.8C15.21 19.8 14.4 18.99 14.4 18C14.4 17.01 15.21 16.2 16.2 16.2H18C18.99 16.2 19.8 17.01 19.8 18V23.4C20.79 23.4 21.6 24.21 21.6 25.2C21.6 26.19 20.79 27 19.8 27ZM18.018 12.6C17.028 12.6 16.2 11.79 16.2 10.8C16.2 9.81 16.992 9 18 9H18.018C19.008 9 19.818 9.81 19.818 10.8C19.818 11.79 19.008 12.6 18.018 12.6Z",
    fill: "#EA2C14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2408_5137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.995615d40fc68fe970221105657454c1.svg";
export { ForwardRef as ReactComponent };